export async function shouldEnableMocking() {
  if (import.meta.env.MODE === 'msw') {
    const { worker } = await import('@/api/browser');

    await worker.start({
      onUnhandledRequest: 'bypass',
      quiet: true,
    });
  }
}

export async function bootstrapApp() {
  const { initializeDataDogFeatureFlags, initializeDataDogLogging, initializeMswFeatureFlags } =
    await import('@/core/data-dog');
  const { setupPdfWorker } = await import('@/core/pdf-worker');

  setupPdfWorker();

  if (import.meta.env.MODE === 'msw') {
    initializeMswFeatureFlags();
  } else {
    initializeDataDogLogging();
    await initializeDataDogFeatureFlags();
  }
}
